import GlobalSearchApi from '../../../../api/GlobalSearchApi';
import { getCurrentRole } from '../../../../components/common/Profile/selector';

import * as TYPES from './TYPES';
// actions
import { addPropertyToItems } from '../SearchResultGrid/helpers';

export const getSeletedType = state => state.globalSearchBar.searchBar.selected;

export const getSeletedNum = state =>
  state.globalSearchBar.searchBar.selectedNum;
export const getInputText = state => state.globalSearchBar.searchBar.input;
export const getShowHistory = state =>
  state.globalSearchBar.searchHistory.showHistory;
export const isFetchingCategoryHistory = state =>
  state.globalSearchBar.searchCategoryHistory.isFetchingHistory;
export const isFetchingHistory = state =>
  state.globalSearchBar.searchHistory.isFetchingHistory;
export const getCategoryHistory = state =>
  state.globalSearchBar.searchCategoryHistory.history;
export const getHistory = state => state.globalSearchBar.searchHistory.history;

export const getSearchResults = state => state.globalSearchBar.searchResult;

// Global search - FETCH Search history
export const fetchSearchBarHistory = params => ({
  type: TYPES.FETCH_SEARCH_HISTORY,
  payload: GlobalSearchApi.fetchSearchHistory(params)
});

export const fetchSearchBarCategoryHistory = params => ({
  type: TYPES.FETCH_SEARCH_CATEGORY_HISTORY,
  payload: GlobalSearchApi.fetchSearchHistory(params)
});

// Global search - SAVE to Search history
export const saveToSearchHistory = (searchTerm, searchCategory) => ({
  type: TYPES.SAVE_SEARCH_TO_HISTORY,
  payload: GlobalSearchApi.saveToSearchHistory(searchTerm, searchCategory),
  meta: searchTerm
});

export const fetchSearchResults = params => (dispatch, getState) => {
  if (!params.fetchParams.lookup) {
    return dispatch({
      type: `${TYPES.FETCH_SEARCH_RESULT}_FULFILLED`,
      payload: {
        Details: [],
        Total: 0,
        dashboardID: null,
        currentPage: 0
      }
    });
  }

  switch (params.type) {
    case TYPES.SEARCHTYPE[1]: // Driver search type
      return dispatch({
        type: TYPES.FETCH_SEARCH_RESULT,
        payload: GlobalSearchApi.fetchDrivers({
          ...params.fetchParams,
          roleId: getCurrentRole(getState()).value
        }).then(data => {
          dispatch(saveToSearchHistory(params.fetchParams.lookup, params.type));

          const vehicles = data.Details;
          const isNewVehicleDash = !!(
            data.ProfileDashboardId && data.ProfileDashboardId.length > 0
          );

          addPropertyToItems(vehicles, [
            {
              name: 'DriverFullName',
              value: ['DriverFirstName', 'DriverSurname']
            },
            {
              name: 'dashVersion',
              value: isNewVehicleDash ? 'v2' : 'v1'
            }
          ]);
          return {
            ...data,
            ...{ Detail: vehicles, currentPage: params.currentPage }
          };
        })
      });
    case TYPES.SEARCHTYPE[0]:
    case TYPES.SEARCHTYPE[2]:
    case TYPES.SEARCHTYPE[3]:
      return dispatch({
        type: TYPES.FETCH_SEARCH_RESULT,
        payload: GlobalSearchApi.fetchVehicles({
          ...params.fetchParams,
          roleId: getCurrentRole(getState()).value
        }).then(data => {
          dispatch(saveToSearchHistory(params.fetchParams.lookup, params.type));

          const drivers = data.Details;
          const isNewDriverDash = !!(
            data.ProfileDashboardId && data.ProfileDashboardId.length > 0
          );
          addPropertyToItems(drivers, [
            {
              name: 'DriverFullName',
              value: ['DriverFirstName', 'DriverSurname']
            },
            {
              name: 'dashVersion',
              value: isNewDriverDash ? 'v2' : 'v1'
            }
          ]);
          return {
            ...data,
            ...{ Detail: drivers, currentPage: params.currentPage }
          };
        })
      });

    default:
      return dispatch({
        type: TYPES.FETCH_SEARCH_RESULT,
        payload: {}
      });
  }
};

// Global search - search type changed reset input text
export const onSelectNum = params => (dispatch, getState) => {
  const state = getState();
  const inputText = getInputText(state);
  const type = getSeletedType(state);
  const rowCount = Number(params.value);
  const fetchParams = {
    offset: 0,
    limit: rowCount,
    lookup: inputText,
    sort: ''
  };

  dispatch(
    fetchSearchResults({
      fetchParams: { ...fetchParams },
      type,
      currentPage: 0
    })
  );
  dispatch({
    type: TYPES.SELECT_NUM_CHANGE,
    payload: { selectedNum: params.value }
  });
};

// Global search - search text changed
export const onInput = params => (dispatch, getState) => {
  if (params && params.fetch) {
    const state = getState();
    const type = getSeletedType(state);
    const rowCount = Number(getSeletedNum(state));

    const fetchParams = {
      offset: 0,
      limit: rowCount,
      lookup: params && params.inputText,
      sort: '',
      lookupType: type
    };
    dispatch(
      fetchSearchResults({
        fetchParams: {
          ...fetchParams
        },
        type,
        currentPage: 0
      })
    );
  }

  dispatch({
    type: TYPES.INPUT_TEXT_CHANGE,
    payload: {
      input: params.inputText || params
    }
  });
};

// Global search - search type changed reset input text
export const onSelect = params => dispatch => {
  const fetchParams = {
    lookup: ''
  };
  dispatch(fetchSearchResults({ fetchParams: { ...fetchParams } }));
  dispatch({
    type: TYPES.SELECT_TYPE_CHANGE,
    payload: { selected: params.value, input: '' }
  });
};

// Global search - search type changed reset input text
export const setShowHistory = params => ({
  type: TYPES.SET_SHOW_HISTORY,
  payload: { showHistory: params }
});



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/store/action.js